/**
 * Size of the <audio> tag pool that Remotion's <Player /> pre-mounts to work around
 * browser autoplay restrictions. Every concurrently mounted <Html5Audio /> claims one
 * slot, and exceeding the pool throws mid-render, which unmounts the whole player.
 *
 * Each video segment can claim two slots when the playback-speed flag is on (see
 * VideoRenderer: MediaBunny resamples audio without preservesPitch, so a companion
 * Html5Audio carries the audio), and splits multiply the segment count. The default
 * of 5 is exceeded after only a couple of splits.
 *
 * Unused slots hold a silent source, so oversizing the pool costs a few idle
 * <audio> elements rather than any decoding work.
 */
export const NUMBER_OF_SHARED_AUDIO_TAGS = 30;
